import '../../styles/Download-Button.css';

export default function Download({File, text}) {

    return (
        <div className="btn-wrapper">  
        <a className='custom-download-btn'  href={File} download={File}>{text}</a>
        </div>
    )

}